(function() {
'use strict';
var SUPPORTS_PASSIVE = false;
try {
var opts = Object.defineProperty({}, 'passive', { get: function() { SUPPORTS_PASSIVE = true; } });
window.addEventListener('test', null, opts);
window.removeEventListener('test', null, opts);
} catch(e) {}
var PASSIVE = SUPPORTS_PASSIVE ? { passive: true } : false;
var IS_TOUCH = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
var IS_MOBILE = window.innerWidth < 768;
var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function initScrollReveal() {
var els = document.querySelectorAll('.reveal, .reveal-scale, .reveal-left, .reveal-right');
if (!els.length) return;
if (REDUCED_MOTION) {
els.forEach(function(el) { el.classList.add('revealed'); });
return;
}
var io = new IntersectionObserver(function(entries) {
entries.forEach(function(e) {
if (e.isIntersecting) {
e.target.classList.add('revealed');
io.unobserve(e.target);
}
});
}, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
els.forEach(function(el) { io.observe(el); });
}
function initStaggerReveal() {
var containers = document.querySelectorAll('[data-stagger]');
if (!containers.length) return;
if (REDUCED_MOTION) {
containers.forEach(function(c) {
Array.prototype.forEach.call(c.children, function(child) { child.classList.add('revealed'); });
});
return;
}
var io = new IntersectionObserver(function(entries) {
entries.forEach(function(e) {
if (e.isIntersecting) {
Array.prototype.forEach.call(e.target.children, function(child, i) {
setTimeout(function() { child.classList.add('revealed'); }, i * 80);
});
io.unobserve(e.target);
}
});
}, { threshold: 0.1 });
containers.forEach(function(el) { io.observe(el); });
}
function initCursorGlow() {
var glow = document.getElementById('glow-cursor');
if (!glow || IS_TOUCH || window.innerWidth < 1024) return;
var mouseX = 0, mouseY = 0, glowX = 0, glowY = 0;
var ticking = false;
document.addEventListener('mousemove', function(e) {
mouseX = e.clientX;
mouseY = e.clientY;
if (!ticking) {
requestAnimationFrame(function() {
glowX += (mouseX - glowX) * 0.08;
glowY += (mouseY - glowY) * 0.08;
glow.style.transform = 'translate(' + glowX + 'px, ' + glowY + 'px)';
ticking = false;
});
ticking = true;
}
}, PASSIVE);
}
function initCounters() {
var counters = document.querySelectorAll('[data-counter]');
if (!counters.length) return;
if (REDUCED_MOTION) return;
var io = new IntersectionObserver(function(entries) {
entries.forEach(function(e) {
if (e.isIntersecting) {
animateCounter(e.target);
io.unobserve(e.target);
}
});
}, { threshold: 0.5 });
counters.forEach(function(el) { io.observe(el); });
}
function animateCounter(el) {
var target = parseInt(el.getAttribute('data-counter'), 10);
var suffix = el.getAttribute('data-counter-suffix') || '';
var prefix = el.getAttribute('data-counter-prefix') || '';
var duration = 1800;
var startTime = null;
function step(ts) {
if (!startTime) startTime = ts;
var p = Math.min((ts - startTime) / duration, 1);
var eased = 1 - Math.pow(1 - p, 4);
el.textContent = prefix + Math.floor(eased * target).toLocaleString() + suffix;
if (p < 1) requestAnimationFrame(step);
}
requestAnimationFrame(step);
}
function initParallax() {
if (IS_MOBILE || REDUCED_MOTION) return;
var els = document.querySelectorAll('[data-parallax]');
if (!els.length) return;
var ticking = false;
window.addEventListener('scroll', function() {
if (ticking) return;
requestAnimationFrame(function() {
var scrollY = window.pageYOffset;
els.forEach(function(el) {
var speed = parseFloat(el.getAttribute('data-parallax')) || 0.15;
var rect = el.getBoundingClientRect();
var offset = (rect.top + scrollY - window.innerHeight / 2) * speed;
el.style.transform = 'translateY(' + offset + 'px)';
});
ticking = false;
});
ticking = true;
}, PASSIVE);
}
function initMagneticButtons() {
if (IS_TOUCH || window.innerWidth < 1024) return;
var wraps = document.querySelectorAll('.magnetic-wrap');
if (!wraps.length) return;
wraps.forEach(function(wrap) {
var btn = wrap.querySelector('.btn') || wrap.firstElementChild;
if (!btn) return;
wrap.addEventListener('mousemove', function(e) {
var rect = wrap.getBoundingClientRect();
var x = e.clientX - rect.left - rect.width / 2;
var y = e.clientY - rect.top - rect.height / 2;
btn.style.transform = 'translate(' + (x * 0.15) + 'px,' + (y * 0.15) + 'px)';
});
wrap.addEventListener('mouseleave', function() {
btn.style.transition = 'transform 0.4s cubic-bezier(0.16,1,0.3,1)';
btn.style.transform = '';
setTimeout(function() { btn.style.transition = ''; }, 400);
});
});
}
function initSmoothScroll() {
document.addEventListener('click', function(e) {
var a = e.target.closest('a[href^="#"]');
if (!a) return;
var href = a.getAttribute('href');
if (href === '#') return;
var target = document.querySelector(href);
if (target) {
e.preventDefault();
target.scrollIntoView({ behavior: REDUCED_MOTION ? 'auto' : 'smooth', block: 'start' });
}
});
}
function initTiltCards() {
if (IS_TOUCH || window.innerWidth < 1024 || REDUCED_MOTION) return;
var cards = document.querySelectorAll('[data-tilt]');
if (!cards.length) return;
cards.forEach(function(card) {
card.addEventListener('mousemove', function(e) {
var rect = card.getBoundingClientRect();
var x = (e.clientX - rect.left) / rect.width - 0.5;
var y = (e.clientY - rect.top) / rect.height - 0.5;
card.style.transform = 'perspective(800px) rotateY(' + (x * 5) + 'deg) rotateX(' + (-y * 5) + 'deg) translateY(-3px)';
});
card.addEventListener('mouseleave', function() {
card.style.transition = 'transform 0.5s cubic-bezier(0.16,1,0.3,1)';
card.style.transform = '';
setTimeout(function() { card.style.transition = ''; }, 500);
});
});
}
function initHeader() {
var header = document.querySelector('.site-header');
if (!header) return;
var lastScroll = 0;
var ticking = false;
window.addEventListener('scroll', function() {
if (ticking) return;
requestAnimationFrame(function() {
var scrollY = window.pageYOffset;
if (scrollY > 40) {
header.classList.add('scrolled');
} else {
header.classList.remove('scrolled');
}
if (IS_MOBILE) {
if (scrollY > lastScroll && scrollY > 120) {
header.classList.add('hidden');
} else {
header.classList.remove('hidden');
}
}
lastScroll = scrollY;
ticking = false;
});
ticking = true;
}, PASSIVE);
}
function initStickyATC() {
var stickyBar = document.querySelector('.sticky-atc-bar');
var productForm = document.getElementById('product-form');
if (!stickyBar || !productForm) return;
if (!IS_MOBILE) return;
var io = new IntersectionObserver(function(entries) {
entries.forEach(function(e) {
if (e.isIntersecting) {
stickyBar.classList.remove('visible');
} else {
stickyBar.classList.add('visible');
}
});
}, { threshold: 0 });
io.observe(productForm);
}
function refreshCartCount() {
fetch('/cart.js')
.then(function(r) { return r.json(); })
.then(function(cart) {
var badges = document.querySelectorAll('.cart-count, .cart-badge, [data-cart-count]');
badges.forEach(function(b) {
b.textContent = cart.item_count;
if (cart.item_count > 0) {
b.removeAttribute('hidden');
b.style.display = '';
}
});
})
.catch(function() {});
}
function initSwipeGallery() {
var galleries = document.querySelectorAll('.product-gallery-main');
if (!galleries.length || !IS_TOUCH) return;
galleries.forEach(function(gallery) {
var startX = 0, startY = 0;
gallery.addEventListener('touchstart', function(e) {
startX = e.touches[0].clientX;
startY = e.touches[0].clientY;
}, PASSIVE);
gallery.addEventListener('touchend', function(e) {
var dx = e.changedTouches[0].clientX - startX;
var dy = e.changedTouches[0].clientY - startY;
if (Math.abs(dx) < 40 || Math.abs(dy) > Math.abs(dx)) return;
var thumbs = document.querySelectorAll('.gallery-thumb');
if (!thumbs.length) return;
var active = document.querySelector('.gallery-thumb.active');
var idx = active ? Array.prototype.indexOf.call(thumbs, active) : 0;
if (dx < 0 && idx < thumbs.length - 1) {
thumbs[idx + 1].click();
} else if (dx > 0 && idx > 0) {
thumbs[idx - 1].click();
}
}, PASSIVE);
});
}
function initMarquee() {
var tracks = document.querySelectorAll('.marquee-track');
tracks.forEach(function(track) {
track.parentElement.addEventListener('mouseenter', function() {
track.style.animationPlayState = 'paused';
});
track.parentElement.addEventListener('mouseleave', function() {
track.style.animationPlayState = 'running';
});
track.parentElement.addEventListener('focusin', function() {
track.style.animationPlayState = 'paused';
});
track.parentElement.addEventListener('focusout', function() {
track.style.animationPlayState = 'running';
});
});
}
function init() {
initScrollReveal();
initStaggerReveal();
initHeader();
initMarquee();
initSmoothScroll();
initCounters();
initSwipeGallery();
initStickyATC();
refreshCartCount();
if (!IS_MOBILE && !IS_TOUCH) {
setTimeout(function() {
initCursorGlow();
initParallax();
initMagneticButtons();
initTiltCards();
}, 200);
}
}
if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', init);
} else {
init();
}
})();